export default "__VITE_ASSET__CdRwq_0T__"